export enum TextVisibility
{
    VISIBLE = "visibility",
    HIDDEN  = "visibility_off"
}